var _path, _path2, _line, _polygon, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    id: "book",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e9d8a6",
    stroke: "#5f363a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M24.33,31.85h12a0,0,0,0,1,0,0V69.5a6,6,0,0,1-6,6h0a6,6,0,0,1-6-6V31.85a0,0,0,0,1,0,0Z",
    transform: "rotate(90 30.345 53.685)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdd7d",
    stroke: "#5f363a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M55.49,46.67a1,1,0,0,1-1,1h-40a6,6,0,0,0-6,6V10.32a6,6,0,0,1,6-6h40a1,1,0,0,1,1,1Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52.18,
    x2: 17.56,
    y1: 53.69,
    y2: 53.69,
    fill: "none",
    stroke: "#5f363a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cbc46d",
    stroke: "#5f363a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    points: "29.55 21.96 24.05 18.01 18.55 21.96 18.55 4.3 29.55 4.3 29.55 21.96"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 55.49,
    x2: 52.18,
    y1: 59.7,
    y2: 59.7,
    fill: "none",
    stroke: "#5f363a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.760bef578d92481e807e3c3ca2eee092.svg";
export { ForwardRef as ReactComponent };